<template lang="pug">
#fake-landing.base-page.first-container
    .hero-container
        img.hero-video(src="@busy-human/k9-library/src/resources/video_preview.jpg")
        .tag-line.text-svg.live-dream
            include ../../../library/src/resources/Tagline.svg
    .section
        .section-header Canine Revolution #[br ] Dog Training Services
        .3-col
            .col-section
                .col-header Dog Training
                .pupper-img
                .description Our Board & Train Programs are our most popular training programs. They take the “legwork” out of the training for the owner and only require maintenance of the training once a dog returns home.
                button.learn Learn More
            .col-section
                .col-header Specialty Training
                .pupper-img
                .description Our Specialty Retrieval Program is suitable for potential service dogs, sport dogs with a formal retrieve, or hunting dogs.
                button.learn Learn More
            .col-section
                .col-header Puppy  Training
                .pupper-img
                .description Learn to train your puppy like the star canine that he is! IN this class well teach you how to teach your puppy to behave like the most wonderful puppy in the neighborhood.
                button.learn Learn More
</template>
<script lang="ts" setup>
import {ref,onMounted} from 'vue'
</script>
<style lang="scss">

/* –––––––––––––––––––––––––––––––––––––––––––––––––––––– */
/* Landing Page */
/* –––––––––––––––––––––––––––––––––––––––––––––––––––––– */
/* Hero Container - (first section) */
/*
    Note: My media queryies for this section is more based
    on content than for media type. So they're very specific
    and the styling will die without the proper numbers x_x
    But they *should* look good on *any* screen
*/
.first-container,
.hero-container,
.dt-hide.hero-container{
    width: 100%;
    --width: 100%;
}
.first-container .hero-container{
    position: relative;
    margin-inline: auto;
    height: fit-content;
    max-width: 1440px;
}
@media screen and (min-width: 1420px){
    .hero-video,
    .video-container{
        max-height: 563px;
        max-width: 930px;
    }
}
@media screen and (max-width:1420px) {
    .first-container .hero-container{
        width: calc(100vw - 50px);
        margin-inline: 0px;
        margin-left: 50px;
    }
}

.tag-line,
.text-svg.live-dream,
.tag-line, .text-svg, .live-dream{
    position: absolute;
    height: auto;
    max-width: 588px;
    left: 0;
    top: 50%;
    transform: translateX(0) translateY(-50%);
    width: calc(40vw - 100px);
    max-width: 620px;
}
.video-container{
    height: 29rem;
}
.hero-video{
    width: 75vw;
}
@media screen and (min-width: 1020px) {
    .tag-line,
    .text-svg.live-dream,
    .tag-line, .text-svg, .live-dream{
        width: calc(50vw - 110px);
        max-width: 590px;
    }
    .hero-video{
        display: flex;
        margin-left: auto;
        margin-right: 0px;
        place-self: flex-end;
        right: 0;
    }
}
@media screen and (max-width: 1020px) {
    .video-container{
        height: fit-content;
    }
    .tag-line,
    .text-svg.live-dream,
    .tag-line, .text-svg, .live-dream{
        max-width: 25vw;
        position: absolute;
        top: 1rem;
        left: 3.125rem;
        transform:translate(0px);
        height: 25vw
    }
    .hero-container{
        width: 100%;
        max-width: 100%;
    }
}

</style>